export class Agent {
    constructor(id, alias, description) {
        this.id = id;
        this.alias = alias;
        this.description = description;
    }
}
